import * as Yup from 'yup';

// File size limit: 10MB in bytes
export const MAX_FILE_SIZE = 10 * 1024 * 1024;

// Supported file formats
export const SUPPORTED_FILE_FORMATS = ['csv', 'ods'];

export const UploadFormSchema = Yup.object()
                                   .shape({
                                              fileName: Yup.string()
                                                           .required('File is required')
                                                           .test('file-format', 'File must be CSV or ODS format', function(value) {
                                                               if (!value) return false;
                                                               const extension = value.split('.').pop()?.toLowerCase();
                                                               return SUPPORTED_FILE_FORMATS.includes(extension || '');
                                                           })
                                                           .test('file-size', `File size must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB`, function(value) {
                                                               // Note: This validation will be enhanced when file object is available
                                                               // For now, we validate the filename exists
                                                               return !!value;
                                                           }),
                                              defaultRegistrarId: Yup.string()
                                                                     .required('Default registrar is required'),
                                              skipDuplicates: Yup.boolean()
                                                                 .default(true),
                                              updateExisting: Yup.boolean()
                                                                 .default(false)
                                          });